import { ContentLog } from "../types/dashboard";

type TimestampInput = number | string | null | undefined;

export const parseContentLogTimestamp = (
  value: TimestampInput
): Date | null => {
  if (value == null || value === "") {
    return null;
  }

  if (typeof value === "number") {
    const milliseconds = value > 9999999999 ? value : value * 1000;
    const date = new Date(milliseconds);
    return Number.isNaN(date.getTime()) ? null : date;
  }

  const numericValue = Number(value);
  if (!Number.isNaN(numericValue) && value.trim() !== "") {
    return parseContentLogTimestamp(numericValue);
  }

  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
};

const isSameInstant = (left: Date | null, right: Date | null): boolean => {
  if (!left || !right) {
    return false;
  }
  return Math.abs(left.getTime() - right.getTime()) <= 2000;
};

const isReconcileFallbackPublishedAt = (log: ContentLog): boolean => {
  const publishedDate = parseContentLogTimestamp(log.published_at);
  const lastCheckedDate = parseContentLogTimestamp(
    log.content?.pfm_result?.last_checked_at
  );
  return isSameInstant(publishedDate, lastCheckedDate);
};

export const getContentLogCalendarDate = (log: ContentLog): Date | null => {
  const status = log.status?.toLowerCase();
  if (status === "published" && log.published_at) {
    const publishedDate = parseContentLogTimestamp(log.published_at);
    if (publishedDate && !isReconcileFallbackPublishedAt(log)) {
      return publishedDate;
    }
  }

  const scheduledFor = log.content?.scheduledFor;
  if (scheduledFor) {
    const scheduledDate = parseContentLogTimestamp(scheduledFor);
    if (scheduledDate) {
      return scheduledDate;
    }
  }

  return parseContentLogTimestamp(log.created_at);
};
